

































import Vue from 'vue';
import {
  Component, Prop, Watch, Inject,
} from 'vue-property-decorator';
import ConfigResource from '@/api/config/ConfigResource';
import { Cycle } from '@/types/cycle';

@Component
export default class FirstBaseTimeoutDialog extends Vue {
	@Inject('ConfigResource')
	private configResource!: ConfigResource;

	@Prop() showDialog!: boolean;

	DEFAULT_FI_ID:string = '99999';

	DEFAULT_TIMER_SECONDS:number = 240;

	numberOfSecondsToTimeout:number = this.DEFAULT_TIMER_SECONDS;

	countdownTimerId:number = 0;

	@Watch('showDialog')
	@Watch('numberOfSecondsToTimeout')
	onShowTimeoutDialogUpdated() {
	  if (this.showDialog) {
	    this.countdownTimerId = setTimeout(() => {
		  this.numberOfSecondsToTimeout--;
		  if (this.numberOfSecondsToTimeout === 0) {
	        FirstBaseTimeoutDialog.handleTimeoutRedirect();
	      }
	    }, 1000);
	  }
	}

	static handleTimeoutRedirect() {
	  const redirect = encodeURIComponent(window.location.href);
	  window.location.href = `/api/auth/login?callback=${redirect}`;
	}

	resetAuthTimer() {
	  // we call a config resource method to reset auth timer
	  this.configResource.loadFiCycleData(this.DEFAULT_FI_ID, '1')
	    .then((result: Cycle[]) => {
		  this.numberOfSecondsToTimeout = this.DEFAULT_TIMER_SECONDS;
	      // do nothing
	    })
	    .catch((error: any) => {
		  this.numberOfSecondsToTimeout = this.DEFAULT_TIMER_SECONDS;
	      // do nothing
	    });
	}
}
